import type { EstufaData } from "../lib/local-types";

const seedId = "20000000-0000-0000-0000-000000000001";
const platformId = "10000000-0000-0000-0000-000000000001";
const deploymentId = "30000000-0000-0000-0000-000000000001";
const now = new Date();
const isoAgo = (days: number, hours = 0) =>
  new Date(now.getTime() - days * 86_400_000 - hours * 3_600_000).toISOString();

export const demoData: EstufaData = {
  platforms: [
    { id: platformId, slug: "nuvemshop", name: "Nuvemshop" },
    { id: "10000000-0000-0000-0000-000000000002", slug: "shopify", name: "Shopify" },
    { id: "10000000-0000-0000-0000-000000000003", slug: "wix", name: "Wix" },
    { id: "10000000-0000-0000-0000-000000000004", slug: "atlassian", name: "Atlassian" },
  ],
  seeds: [
    {
      id: seedId,
      seedKey: "seed-001",
      name: "CorrigePedido",
      summary: "Correção self-service de variação antes do envio.",
      status: "staging",
      createdAt: isoAgo(10),
    },
  ],
  deployments: [
    {
      id: deploymentId,
      seedId,
      platformId,
      platformSlug: "nuvemshop",
      name: "CorrigePedido / Nuvemshop",
      externalAppId: "39951",
      status: "staging",
      isPrimary: true,
    },
  ],
  installations: Array.from({ length: 28 }, (_, index) => ({
    id: `demo-install-${index}`,
    deploymentId,
    tenantId: `demo-store-${index}`,
    status: index < 3 ? "uninstalled" : "active",
    installedAt: isoAgo(27 - index),
    activatedAt: index < 24 ? isoAgo(27 - index, -1) : null,
    onboardingCompletedAt: index < 22 ? isoAgo(27 - index, -2) : null,
    firstValueAt: index < 19 ? isoAgo(27 - index, -3) : null,
    trialStartedAt: index < 16 ? isoAgo(27 - index, -4) : null,
    paidStartedAt: index < 11 ? isoAgo(26 - index) : null,
    uninstalledAt: index < 3 ? isoAgo(2 - index) : null,
  })),
  events: [],
  subscriptions: Array.from({ length: 11 }, (_, index) => ({
    id: `demo-sub-${index}`,
    deploymentId,
    tenantId: `demo-store-${index + 3}`,
    status: index === 0 ? "canceled" : "active",
    planExternalId: "starter",
    mrrCents: 3990,
    currency: "BRL",
    startedAt: isoAgo(18 - index),
    trialStartedAt: isoAgo(20 - index),
    trialEndsAt: null,
    canceledAt: index === 0 ? isoAgo(2) : null,
  })),
  metricSnapshots: [],
  revenue: Array.from({ length: 10 }, (_, index) => ({
    id: `demo-rev-${index}`,
    deploymentId,
    tenantId: `demo-store-${index + 4}`,
    amountCents: 3990,
    currency: "BRL",
    kind: "subscription",
    recognizedAt: isoAgo(9 - index),
  })),
  releases: [
    {
      id: "r-v9",
      deploymentId,
      version: "v9",
      commitSha: "d948aad",
      summary: "Renderização estável no checkout success com clearSlot + array + keys.",
      hypothesis: "O host do NubeSDK materializará corretamente a UI interativa.",
      riskLevel: "medium",
      status: "released",
      releasedAt: isoAgo(0, 2),
    },
    {
      id: "r-v8",
      deploymentId,
      version: "v8",
      commitSha: "41c0a82",
      summary: "Estabilidade do lifecycle e Select sem value vazio.",
      hypothesis: null,
      riskLevel: "medium",
      status: "released",
      releasedAt: isoAgo(1),
    },
  ],
  decisions: [
    {
      id: "d1",
      seedId,
      deploymentId,
      title: "Manter V1 estreita: mesma variação, mesmo preço e UNPACKED",
      category: "product",
      hypothesis: "Escopo menor aumenta confiabilidade e reduz risco operacional.",
      changeSummary: "Congelamos a V1 sem endereço, refund, add product ou quantity change.",
      rationale: "Core confiável antes de feature count.",
      targetMetric: "incident_rate",
      observedResult: null,
      verdict: null,
      confidence: 85,
      decidedAt: isoAgo(8),
    },
  ],
  lessons: [
    {
      id: "l1",
      sourceSeedId: seedId,
      category: "platform",
      evidenceType: "observed",
      confidence: 95,
      lesson: "Testar o contrato visual real do host antes de multiplicar hipóteses de backend.",
      whatHappened: "Backend elegível estava correto, mas o Select não materializava no slot.",
      whyWeThinkItHappened:
        "O padrão de renderização do host exigiu uma forma mais estrita na prática.",
      whatToRepeat: "Isolar backend e host separadamente e validar com prova real.",
      whatNotToRepeat: "Criar muitas versões sem uma hipótese discriminante.",
      appliesTo: "Integrações UI hospedadas por plataformas",
      createdAt: isoAgo(0, 1),
    },
  ],
  incidents: [
    {
      id: "inc1",
      deploymentId,
      title: "Telemetria de correction events não persistiu em staging",
      severity: "medium",
      status: "open",
      openedAt: isoAgo(0, 1),
      resolvedAt: null,
      releaseVersion: "v9",
    },
  ],
  experiments: [],
  supportTickets: [],
  reviews: [],
  opportunityScores: [],
  researchApps: [],
};
